/*
  Private bowling lessons - progressive enhancement only.

  The add-to-cart behaviour is handled entirely by the theme's native
  <product-form> element (product-form.js). This file adds two small things
  and the page works fully without it:

  1. A guarded in-page scroll from the hero CTA to the plans, which also moves
     keyboard focus so the jump is announced. Honours prefers-reduced-motion.
  2. A double-submit guard for the no-JS-cart fallback, used only when neither
     a cart drawer nor a cart notification exists on the page (in that case the
     form performs a normal POST and a second click could add the item twice).
  3. The coaching video's optional cover image. It is rendered hidden and only
     revealed here, so without JavaScript the visitor gets the native player
     with its own poster frame instead of an overlay that cannot be dismissed.
*/

(function () {
  'use strict';

  var sections = document.querySelectorAll('.am-private-lessons');
  if (!sections.length) return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var hasAjaxCart = !!(document.querySelector('cart-drawer') || document.querySelector('cart-notification'));

  sections.forEach(function (section) {
    section.querySelectorAll('[data-am-scroll-to]').forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        var target = document.getElementById(trigger.dataset.amScrollTo);
        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({
          behavior: prefersReducedMotion.matches ? 'auto' : 'smooth',
          block: 'start',
        });
        target.focus({ preventScroll: true });
      });
    });

    section.querySelectorAll('[data-am-video-cover]').forEach(function (cover) {
      var video = cover.parentElement && cover.parentElement.querySelector('video');
      if (!video) return;

      cover.hidden = false;

      cover.addEventListener('click', function () {
        cover.hidden = true;
        video.focus({ preventScroll: true });

        var played = video.play();
        if (played && typeof played.catch === 'function') {
          played.catch(function () {
            /* Autoplay policies can refuse; the native controls still work. */
          });
        }
      });
    });

    if (hasAjaxCart) return;

    section.querySelectorAll('.am-pl-plan__form form').forEach(function (form) {
      form.addEventListener('submit', function () {
        var button = form.querySelector('[type="submit"]');
        if (!button || button.disabled) return;

        button.setAttribute('aria-busy', 'true');
        button.classList.add('loading');

        var spinner = button.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        // Re-enable on bfcache restore so the back button leaves a usable page.
        window.setTimeout(function () {
          button.disabled = true;
        }, 0);
      });
    });
  });

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    document.querySelectorAll('.am-private-lessons .product-form__submit').forEach(function (button) {
      if (button.hasAttribute('aria-busy')) {
        button.removeAttribute('aria-busy');
        button.classList.remove('loading');
        button.disabled = false;
      }
    });
  });
})();
